<template>
  <div class="relative">
    <shipblu-table
     :sst="true"
      @search="handleSearch"
      @keyup.enter.native="handleSearch"
      search
      :max-items="maximumItems"
      :data="refunds"
      :tableLoader="tableLoader"
    >
      <template slot="header">
        <div class="lg:w-auto w-full">
          <table-filter icon="BarChart2Icon" filterLabel="Status" :filters="filters" :statusFilters="statusFilters" @changeFilter="changeFilter" @filterValue="filterValue = $event"/>
        </div>
      </template>

      <template slot="thead">
        <shipblu-th>{{$t('Merchant Name')}}</shipblu-th>
        <shipblu-th>{{$t('Merchant ID')}}</shipblu-th>
        <shipblu-th>{{$t('Request Date')}}</shipblu-th>
        <shipblu-th>{{$t('Withdraw Amount')}}</shipblu-th>
        <shipblu-th>{{$t('Status')}}</shipblu-th>
        <shipblu-th v-if="$store.state.AppActiveUser.userRole === 'finance'">{{refunds.filter(item => item.status === 'refunded' || item.status === 'rejected').length !== refunds.length ? $t('Actions') : ''}}</shipblu-th>
      </template>

      <template slot-scope="{ data }">
        <shipblu-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <shipblu-td :data="data[indextr].merchant_name">
            {{data[indextr].merchant_name}}
          </shipblu-td>

          <shipblu-td :data="data[indextr].merchant">
            {{data[indextr].merchant}}
          </shipblu-td>
          
          <shipblu-td :data="data[indextr].merchant">
            {{ new Date(data[indextr].created).toLocaleDateString('fr-CA') }}
          </shipblu-td>

          <shipblu-td :data="data[indextr].requested_amount">
            {{data[indextr].requested_amount}}
          </shipblu-td>

          <shipblu-td :data="data[indextr].status">
            <div @click="`${data[indextr].status === 'rejected' ? showRejectionReason(data[indextr].id, data[indextr].comment) : '' }`" :class="`${data[indextr].status === 'rejected' ? 'underline' : ''}`">
              {{data[indextr].status === 'requested' ? $t('Refund Requested') : data[indextr].status === 'under_review' ? $t('Under Review') : data[indextr].status === 'refunded' ? $t('Approved') : $t('Rejected')}}
            </div>
          </shipblu-td>

          <shipblu-td v-if="$store.state.AppActiveUser.userRole === 'finance'">
            <div v-if="data[indextr].status !== 'rejected' && data[indextr].status !== 'refunded'">
              <vs-button v-if="data[indextr].status !== 'under_review'" @click="changeRefundStatus(data[indextr].id, 'under_review')">{{ $t('Review') }}</vs-button>
              <div v-if="data[indextr].status === 'under_review'" class="flex gap-2">
                <vs-button class="bg-grey h-10 w-10 flex justify-center" @click="changeRefundStatus(data[indextr].id, 'refunded')">
                  <span class="material-icons-outlined text-xl">check</span>
                </vs-button>
                <vs-button class="bg-red h-10 w-10 flex justify-center" @click="openRejectionModal(data[indextr].id)">
                  <span class="material-icons-outlined text-xl">close</span>
                </vs-button>
              </div>
            </div>
          </shipblu-td>
        </shipblu-tr>
      </template>
    </shipblu-table>
    <shipblu-pagination :maximumItems="maximumItems" :noOptions="true" :totalRows="totalRows" :currentPage="currentPage" @currentPage="currentPage = $event" />

    <shipblu-prompt
      @close="closeModal"
      :active.sync="selectReasonModal"
      :title="$t('Select the rejection reasons')"
      :buttons-hidden="true">
      <div>
        <v-select v-validate="'required'" name="reason" :placeholder="$t('Select the rejection reasons')" :options="reasons" v-model="reason" label="name" class="w-full"/>
        <span class="text-danger text-sm" v-show="errors.has('reason')">{{ errors.first('reason') }}</span>
      </div>
      <div class="grid grid-cols-2 gap-4 mt-4">
        <button @click="closeModal" class="btn disable-btn">{{ $t('Cancel') }}</button>
        <button @click="changeRefundStatus(withdrawalsId, 'rejected', reason ? reason.name : '')"  class="active-btn btn">{{ $t('Add') }}</button>
      </div>
    </shipblu-prompt>

    <shipblu-prompt
      @close="closeModal"
      :active.sync="rejectionReasonModal"
      :title="$t('Rejection Reason')"
      :buttons-hidden="true">
      <div>
        <p class="text-dried-lavender-flowers">{{ $t(rejectionReason) }}</p>
      </div>
    </shipblu-prompt>
  </div>
</template>

<script>
import ShipbluTable from '../../../layouts/components/NewShipBluTable.vue'
import ShipbluTr from '../../../layouts/components/ShipBluTr.vue'
import ShipbluTh from '../../../layouts/components/ShipBluTh.vue'
import ShipbluTd from '../../../layouts/components/ShipBluTd.vue'
import ShipbluPagination from '../../../layouts/components/ShipbluPagination.vue'
import common from '../../../assets/utils/common'
import TableFilter from '../../merchant/components/TableFilter.vue'
import ShipbluPrompt from '../../../layouts/components/ShipBluPrompt.vue'
import vSelect from 'vue-select'
import { sendRequest } from '../../../http/axios/requestHelper'
import i18nData from '../../../i18n/i18nData'

export default {
  data () {
    return {
      statusFilters: [
        {
          name: 'All',
          value: 'all'
        },
        {
          name: 'Refund Requested',
          value: 'requested'
        },
        {
          name: 'Under Review',
          value: 'under_review'
        },
        {
          name: 'Approved',
          value: 'refunded'
        },
        {
          name: 'Rejected',
          value: 'rejected'
        }
      ],
      filters: [],
      maximumItems: localStorage.getItem('maxItems') ? Number(localStorage.getItem('maxItems')) : process.env.VUE_APP_MAXIMUM_ITEMS_TABLE,
      refunds: [],
      offset: 0,
      totalRows: 0,
      currentPage: (this.$route.query.page &&  Number(this.$route.query.page) > 0) ? Number(this.$route.query.page) : 1,
      searchVal: '',
      searchInProgress: false,
      searchedValue: ' ',
      tableLoader: false,
      selectReasonModal: false,
      filterValue: '',
      withdrawalsId: '',
      reason: '',
      rejectionReason: '',
      rejectionReasonModal: false
    }
  },
  watch: {
    currentPage () {
      this.offset = (this.currentPage - 1) * this.maximumItems
      this.$router.push(
        {
          query: {
            tab: this.$route.query.tab,
            filter: this.filters,
            page: this.currentPage
          }
        }
      ).catch(() => {})
      this.loadRefundRequests()
    },
    '$route.query.filter' () {
      if (!this.$route.query.filter) {
        this.filters = []
        this.loadRefundRequests()
      }
    }
  },
  computed: {
    reasons () {
      return [
        { id: 1,
          name: this.$t('Insufficient Balance')
        },
        { id: 2,
          name: this.$t('Zero COD Wih On Hold Orders')
        },
        { id: 3,
          name: this.$t('No Payout Method')
        },
        { id: 4,
          name: this.$t('Wrong Bank Details')
        },
        { id: 5,
          name: this.$t('Duplicate Request')
        },
        { id: 6,
          name: this.$t('Others...')
        }
      ]
    }
  },
  methods: {
    openRejectionModal (id) {
      this.selectReasonModal = true
      this.$validator.resume()
      this.withdrawalsId = id
    },
    showRejectionReason (id, comment) {
      this.rejectionReasonModal = true
      this.withdrawalsId = id
      this.rejectionReason = comment
    },
    handleSearch (search) {
      this.offset = 0
      this.currentPage = 1
      this.searchVal = search.target ? search.target.value : search
      return common.manageSearch(search, this.loadRefundsSearch)
    },
    loadRefundsSearch () {
      if (this.searchInProgress || this.searchedValue === this.searchVal) {
        return
      }
      this.loadRefundRequests()
    },
    loadRefundRequests () {
      this.searchInProgress = true
      this.tableLoader = true
      const query = `?offset=${this.offset}&limit=${this.maximumItems}&search=${this.searchVal}&status=${this.filters}`
      sendRequest(false, false, this, `api/v1/merchant-wallet-refunds/${query}`, 'get', null, true,
        (response) => {
          this.refunds = response.data.results
          this.totalRows = response.data.count
          this.searchInProgress = false
          this.searchedValue = this.searchVal
          this.tableLoader = false
        }
      )
    },
    changeRefundStatus (id, status, reason) {
      this.$validator.validateAll().then(result => {
        if (result) {
          const refundStatus = {
            status,
            comment: reason
          }
          sendRequest(false, false, this, `api/v1/merchant-wallet-refunds/${id}/`, 'patch', refundStatus, true,
            () => {
              this.$vs.notify({
                color:'success',
                title:i18nData[this.$i18n.locale]['Success'],
                text:i18nData[this.$i18n.locale][status === 'under_review' ? 'Under Review' : status === 'refunded' ? 'Approved' : 'Rejected'],
                position: 'top-center'
              })
              this.closeModal()
              this.loadRefundRequests()
            }
          )
        }
      })
    },
    changeFilter () {
      this.filters = [this.filterValue]
      if (this.filterValue === 'all') {
        this.filters = []
      }
      this.$router.push({
        query: {
          tab: this.$route.query.tab,
          filter: this.filters,
          page: this.currentPage
        }
      }).catch(() => {})
      this.loadRefundRequests()
    },
    closeModal () {
      this.selectReasonModal = false
      this.rejectionReasonModal = false
      this.$validator.pause()
      this.loadRefundRequests()
      this.withdrawalsId = ''
      this.reason = ''
      this.rejectionReason = ''
    }
  },
  components: {
    ShipbluTable,
    ShipbluTr,
    ShipbluTh,
    ShipbluTd,
    ShipbluPagination,
    TableFilter,
    ShipbluPrompt,
    vSelect
  },
  created () {
    this.filters = this.$route.query.filter ? typeof (this.$route.query.filter) === 'string' ? Array(this.$route.query.filter) : this.$route.query.filter : []
    this.loadRefundRequests()
  }
}
</script>